import React, { useState, useEffect, useCallback } from 'react';
import LiveCount from './LiveCount';
import './Countdown.css';

const Countdown = ({ nextSessionTime, sessionIntervalMinutes }) => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    if (!nextSessionTime) return;
    
    const updateCountdown = () => {
      const now = new Date();
      const timeDiff = nextSessionTime.getTime() - now.getTime();
      
      if (timeDiff > 0) {
        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        
        setTimeLeft({ hours, minutes, seconds });
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [nextSessionTime]);

  const formatTime = useCallback((value) => value.toString().padStart(2, '0'), []);

  // Show loading state if nextSessionTime is not available
  if (!nextSessionTime) {
    return (
      <div className="countdown-container">
        <LiveCount key="live-count" />
        <div className="countdown-content">
          <h1 className="countdown-title">World Rosary</h1>
          <p className="countdown-subtitle">
            Loading next session...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="countdown-container">
      <LiveCount key="live-count" />
      <div className="countdown-content">
        <h1 className="countdown-title">World Rosary</h1>
        <p className="countdown-subtitle">
          Join millions around the world in synchronized prayer
        </p>
        
        <p className="countdown-message">
          Next rosary session begins in:
        </p>
                
        <div className="countdown-timer">
          <div className="time-unit">
            <div className="time-value">{formatTime(timeLeft.minutes)}</div>
            <div className="time-label">Minutes</div>
          </div>
          <div className="time-separator">:</div>
          <div className="time-unit">
            <div className="time-value">{formatTime(timeLeft.seconds)}</div>
            <div className="time-label">Seconds</div>
          </div>
        </div>
        

        <div className="session-info">
          <p>New sessions start every 30 minutes on the hour and half hour</p>
          <p>All prayers are synchronized worldwide</p>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
